<template>
    <component :is="tag" :class="patientNameClasses" @click="goToPatientDetails">
        <slot>{{ patientFullName }}</slot>
    </component>
</template>

<script>
    import { composeDisplayName } from 'components/common/CommonUserName'

    export default {
        name: 'common-patient-name',

        props: {
            patient: { type: [Object, String, Number], default: null },
            clickable: { type: Boolean, default: true },
            tag: { type: String, default: 'span' },
            customClass: { type: String, default: '' },
        },

        computed: {
            patientId() {
                if (typeof this.patient === 'object' && this.patient !== null) {
                    return (
                        this.patient.id ||
                        this.patient.patientId ||
                        this.patient.referralInfo?.patientId ||
                        this.patient.referralInfo?.patient?.id ||
                        this.patient.referralData?.patientId ||
                        this.patient.referralData?.patient?.id ||
                        null
                    )
                }
                if (typeof this.patient === 'number' || (typeof this.patient === 'string' && /^\d+$/.test(this.patient))) {
                    return this.patient
                }
                return null
            },

            isClickable() {
                return Boolean(this.clickable && this.patientId)
            },

            patientFullName() {
                if (typeof this.patient === 'string' && this.patient && !/^\d+$/.test(this.patient)) {
                    return this.patient
                }

                const obj = typeof this.patient === 'object' && this.patient !== null ? this.patient : {}
                const target = obj.patient || obj.referralInfo?.patient || obj.referralData?.patient || obj

                if (target.firstName || target.lastName) {
                    return composeDisplayName({
                        firstName: target.firstName || '',
                        middleName: target.middleName || '',
                        lastName: target.lastName || '',
                    }).trim()
                }

                return target.name || target.patientName || target.patient_name || 'N/A'
            },

            patientNameClasses() {
                return [
                    'patient-name',
                    {
                        'patient-name--clickable': this.isClickable,
                    },
                    this.customClass,
                ]
            },
        },

        methods: {
            goToPatientDetails(event) {
                if (!this.isClickable) return

                event.stopPropagation()

                if (
                    this.$route.name === 'patients.details.patients' &&
                    String(this.$route.params?.id) === String(this.patientId)
                ) {
                    return
                }

                this.$router
                    .push({
                        name: 'patients.details.patients',
                        params: { id: this.patientId },
                    })
                    .catch(() => {})
            },
        },
    }
</script>

<style lang="scss" scoped>
    .patient-name {
        display: inline;
        color: inherit;
        text-decoration: none;

        &--clickable {
            color: #2563eb;
            font-weight: 500;
            cursor: pointer;
            text-decoration: underline;
            text-decoration-color: rgba(37, 99, 235, 0.4);
            text-underline-offset: 3px;
            transition: color 0.15s ease, text-decoration-color 0.15s ease;

            &:hover {
                color: #1d4ed8;
                text-decoration: underline;
                text-decoration-color: #1d4ed8;
            }

            &:active {
                color: #1e40af;
            }
        }
    }
</style>
